// Voices a talking NPC can use. Shared by the builder (pickers) and the server
// (functions/api/npc/talk.ts), which only accepts ids from these lists.
//   standard — Lemonfox TTS (Kokoro voices), 1 talk credit per reply
//   premium  — ElevenLabs (eleven_v4), 5 talk credits per reply

export type NpcVoiceTier = 'standard' | 'premium';
export interface NpcVoice { id: string; label: string; gender: 'Female' | 'Male' }

export const NPC_TALK_UNITS: Record<NpcVoiceTier, number> = { standard: 1, premium: 5 };

export const LEMONFOX_VOICES: NpcVoice[] = [
  { id: 'heart', label: 'Heart (warm)', gender: 'Female' },
  { id: 'bella', label: 'Bella (bright)', gender: 'Female' },
  { id: 'nicole', label: 'Nicole (soft)', gender: 'Female' },
  { id: 'sarah', label: 'Sarah (clear)', gender: 'Female' },
  { id: 'sky', label: 'Sky (young)', gender: 'Female' },
  { id: 'nova', label: 'Nova (calm)', gender: 'Female' },
  { id: 'michael', label: 'Michael (warm)', gender: 'Male' },
  { id: 'adam', label: 'Adam (deep)', gender: 'Male' },
  { id: 'eric', label: 'Eric (upbeat)', gender: 'Male' },
  { id: 'liam', label: 'Liam (friendly)', gender: 'Male' },
  { id: 'onyx', label: 'Onyx (low)', gender: 'Male' },
  { id: 'puck', label: 'Puck (playful)', gender: 'Male' },
];

// ElevenLabs premade voices (available on every account).
export const ELEVENLABS_VOICES: NpcVoice[] = [
  { id: 'EXAVITQu4vr4xnSDxMaL', label: 'Sarah (soft)', gender: 'Female' },
  { id: 'FGY2WhTYpPnrIDTdsKH5', label: 'Laura (upbeat)', gender: 'Female' },
  { id: 'XB0fDUnXU5powFXDhCwa', label: 'Charlotte (smooth)', gender: 'Female' },
  { id: 'Xb7hH8MSUJpSbSDYk0k2', label: 'Alice (confident)', gender: 'Female' },
  { id: 'XrExE9yKIg1WjnnlVkGX', label: 'Matilda (warm)', gender: 'Female' },
  { id: 'cgSgspJ2msm6clMCkdW9', label: 'Jessica (playful)', gender: 'Female' },
  { id: 'nPczCjzI2devNBz1zQrb', label: 'Brian (deep)', gender: 'Male' },
  { id: 'onwK4e9ZLuTAKqWW03F9', label: 'Daniel (steady)', gender: 'Male' },
  { id: 'iP95p4xoKVk53GoZ742B', label: 'Chris (casual)', gender: 'Male' },
  { id: 'cjVigY5qzO86Huf0OWal', label: 'Eric (smooth)', gender: 'Male' },
  { id: 'TX3LPaxmHKxFdv7VOQHJ', label: 'Liam (energetic)', gender: 'Male' },
  { id: 'JBFqnCBsd6RMkjVDRZzb', label: 'George (warm)', gender: 'Male' },
];

export const voicesFor = (tier: NpcVoiceTier) => (tier === 'premium' ? ELEVENLABS_VOICES : LEMONFOX_VOICES);
/** A sensible default voice for an NPC's gender and tier. */
export const defaultVoice = (tier: NpcVoiceTier, gender: string) =>
  (voicesFor(tier).find((v) => v.gender === gender) ?? voicesFor(tier)[0]).id;
